import React from "react";
import { Typography, Slider, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { ReactComponent as City } from "../../assets/img-city.svg";
import { ReactComponent as Stars } from "../../assets/img-stars.svg";
import PatientBrief from "./PatientBrief";
const { Text } = Typography;
const SearchFilters = (props) => {
  const {
    onDistanceChange,
    onClassificatinChange,
    onResetFilters,
    distance,
    classification,
    patient,
  } = props;
  const marks = {
    0: {
      style: {
        color: "rgba(0, 0, 0, 0.45)",
      },
      label: "0",
    },
    100: {
      style: {
        color: "rgba(0, 0, 0, 0.45)",
      },
      label: "100",
    },
  };
  return (
    <div className="filters">
      <PatientBrief patient={patient} />
      <div className="divider" />
      <div className="header">
        <Text type="secondary">
          {<FormattedMessage id="app.scheduling.distance" />}
        </Text>
      </div>
      <div className="sliderContainer">
        <City className="img" />
        <Slider
          onChange={onDistanceChange}
          className="distanceFilter"
          value={distance}
          marks={marks}
          style={{ width: "100%", margin: "0px", padding: "0px" }}
        />
      </div>
      <div className="divider" />
      <div className="divider" />
      <div className="header">
        <Text type="secondary">
          {<FormattedMessage id="app.scheduling.classification" />}
        </Text>
      </div>
      <div className="sliderContainer">
        <Stars />
        <Slider
          onChange={onClassificatinChange}
          className="classificationFilter"
          value={classification}
          marks={marks}
          style={{ width: "100%" }}
        />
      </div>
      <div className="divider" />
      <div className="divider" />
      <Button type="text" danger onClick={onResetFilters}>
        {<FormattedMessage id="app.scheduling.resetFilters" />}
      </Button>
    </div>
  );
};

export default SearchFilters;
